import {AbstractTransitionManager} from './AbstractTransitionManager';
import {DPlexArguments} from './DPlexArguments';
import {FadeTransition} from './transitions/FadeTransition';
import {Hamburger} from './Hamburger';
import {SmoothScroll} from './SmoothScroll';

export class TransitionManager extends AbstractTransitionManager {

    public async navigate(args:DPlexArguments) {
        let md=args.metadata;
        let smoothy=new SmoothScroll();
        let sy=md.enter.scrollY;
        let hash=location.hash;

        new Hamburger($('.hamburger')).close();
        smoothy.setScrollUpdate(false);

        if (hash) {
            $('.leave').hide();
            let pos=smoothy.getTargetPosition(hash);
            $('.leave').show();
            args.metadata.enter.scrollY=pos;
        }

        $('body').toggleClass('front', !!md.enter.is_front);

        await new FadeTransition(args).play();
        this.updateZones(args);
        $('.main-mobile.open').removeClass('open').css('display','');
    }

    private updateZones(args:DPlexArguments) {
        $('[data-zone]').each((index,element) => {
            this.updateZone(args,$(element).data('zone'));
        });
    }
}

export {};